import { useEventListener } from "@vueuse/core";

/**
 * Toggles `--selected` on the table row of each `sp-menu` that opens or closes inside `container`.
 *
 * @param {import("vue").Ref<EventTarget | null>} container - Ref to the element whose descendants' menu events are tracked.
 */
export function useMenuRowSelection(container) {
  function selectRow(target, open) {
    target.closest("tr")?.classList.toggle("--selected", Boolean(open));
  }

  function onMenuOpen({ detail, target }) {
    if (target.localName === "sp-menu") {
      selectRow(target, detail?.[0]);
    }
  }

  useEventListener(container, "update-open", onMenuOpen, { capture: true });
}
